import axios from 'axios';
import store from '../../store/'
import cacheConfig from './config'
const CancelToken = axios.CancelToken
export const setUpCache = ()=>{
  // 添加请求拦截器
  axios.interceptors.request.use(function (config) {
    let useCache = store.getters.bogo_switch
    let accessCode = config.headers['Authorization-Method']
    if (useCache && cacheConfig[accessCode]) {
      let source = CancelToken.source()
      config.cancelToken = source.token
      // 去缓存池获取缓存数据
      let cache = getUserCache(accessCode.MD5())
      // 判断缓存池中是否存在已有数据 存在的话 再判断是否过期
      // 未过期 source.cancel会取消当前的请求 并将内容返回到拦截器的err中
      if (cache) {
        if (cache.expired > new Date()) {
          console.log('useCache',config.url,new Date(cache.expired).toLocaleString())
          source.cancel({useCache:true,data:cache.data})
        } else {
          removeUserCache(accessCode.MD5())
        }
        
      }
    }
    // 在发送请求之前做些什么
    return config;
  }, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  });

  // 添加响应拦截器
  axios.interceptors.response.use(function (response) {
    let config = response.config
    let useCache = store.getters.bogo_switch
    let accessCode = config.headers['Authorization-Method']
    if (useCache && response.status == 200) {
      if (cacheConfig[accessCode]) {
        setUserCache(accessCode.MD5(),response,cacheConfig[accessCode].expired)
      }
      for (let key in cacheConfig) {
        if (cacheConfig[key].relatedAPI.indexOf(accessCode) != -1) {
          removeUserCache(key.MD5())
        }
      }
    }
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    return response;
  }, function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    return Promise.reject(error);
  });
}

export const cleanUserCache = () => {
  localStorage.removeItem("UserCache");
}

export const setUserCache = (key,data,expired) => {
  let cacheStr = localStorage.getItem("UserCache");
  let cache = {}
  try {
    cache = JSON.parse(cacheStr) || {}
  } catch(e) {
    cache = {}
  }
  cache[key] = {
    data,
    expired:new Date().getTime() + expired
  }
  localStorage.setItem('UserCache',JSON.stringify(cache))
}

export const removeUserCache = (key) => {
  let cacheStr = localStorage.getItem("UserCache");
  let cache = {}
  try {
    cache = JSON.parse(cacheStr) || {}
  } catch(e) {
    cache = {}
  }
  cache[key] = null
  localStorage.setItem('UserCache',JSON.stringify(cache))
}

export const getUserCache = (key) => {
  let cacheStr = localStorage.getItem("UserCache");
  let cache = {}
  try {
    cache = JSON.parse(cacheStr) || {}
  } catch(e) {
    cache = {}
  }
  let hintCache = cache[key]
  return hintCache
}

